import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LottieModule } from 'ngx-lottie';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { IsInViewDirective } from 'src/directives/is-in-view.directive';

// Note we need a separate function as it's required
// by the AOT compiler.
export const playerFactory = () => import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            innerHTMLTemplatesEnabled: true
        }),
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        LottieModule.forRoot({ player: playerFactory })
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        CurrencyPipe,
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
